module.exports = __webpack_public_path__ + "img/paymentFailed.ace18406.png";